import type {
  LineAnnotationProps,
  PointAnnotationProps,
} from '../../../../../../../packages/image-annotator/src/lib/types/props';
import type { LatestImageBoneLevels } from '../../../../../@types/latestImagesV2';
import {
  green400,
  orange700,
  purple500,
  red400,
  yellow500,
} from '../../../../../theme/videa-style-tokens';

const tierToColorMap = {
  red: red400,
  orange: orange700,
  yellow: yellow500,
  green: green400,
};

export const getRblPoints = (input: {
  boneLevels: LatestImageBoneLevels[];
}) => {
  const { boneLevels } = input;
  return boneLevels.flatMap((boneLevel) => {
    const points: PointAnnotationProps[] = [];
    const styles = { strokeColor: purple500, strokeWidth: 4 };

    if (boneLevel.distalRoot) {
      points.push({
        x: boneLevel.distalRoot.coordinates[0] as number,
        y: boneLevel.distalRoot.coordinates[1] as number,
        id: `${boneLevel.id}-distalRoot`,
        styles,
      });
    }

    if (boneLevel.mesialRoot) {
      points.push({
        x: boneLevel.mesialRoot.coordinates[0] as number,
        y: boneLevel.mesialRoot.coordinates[1] as number,
        id: `${boneLevel.id}-mesialRoot`,
        styles,
      });
    }

    return points;
  });
};

export const getRblLines = (input: { boneLevels: LatestImageBoneLevels[] }) => {
  const { boneLevels } = input;
  return boneLevels.flatMap((boneLevel) => {
    const lines: LineAnnotationProps[] = [];

    const style = {
      strokeColor: green400,
      strokeWidth: 3,
      strokeDashArray: [5, 3],
      showHandles: true,
      handleRadius: 2,
    };

    if (
      boneLevel.mesialLine?.coordinates &&
      boneLevel.mesialLine.coordinates[0] &&
      boneLevel.mesialLine.coordinates[1]
    ) {
      const strokeColor =
        tierToColorMap[boneLevel.mesialTier as keyof typeof tierToColorMap] ??
        tierToColorMap.green;

      lines.push({
        x1: boneLevel.mesialLine.coordinates[0][0] as number,
        y1: boneLevel.mesialLine.coordinates[0][1] as number,
        x2: boneLevel.mesialLine.coordinates[1][0] as number,
        y2: boneLevel.mesialLine.coordinates[1][1] as number,
        id: `${boneLevel.id}-mesial`,
        styles: {
          ...style,
          strokeColor,
        },
      });
    }

    if (
      boneLevel.distalLine?.coordinates &&
      boneLevel.distalLine.coordinates[0] &&
      boneLevel.distalLine.coordinates[1]
    ) {
      const strokeColor =
        tierToColorMap[boneLevel.distalTier as keyof typeof tierToColorMap] ??
        tierToColorMap.green;

      lines.push({
        x1: boneLevel.distalLine.coordinates[0][0] as number,
        y1: boneLevel.distalLine.coordinates[0][1] as number,
        x2: boneLevel.distalLine.coordinates[1][0] as number,
        y2: boneLevel.distalLine.coordinates[1][1] as number,
        id: `${boneLevel.id}-distal`,
        styles: {
          ...style,
          strokeColor,
        },
      });
    }

    return lines;
  });
};
